import { render, staticRenderFns } from "./Respiracion.vue?vue&type=template&id=6e162c3c&scoped=true"
import script from "./Respiracion.vue?vue&type=script&lang=js"
export * from "./Respiracion.vue?vue&type=script&lang=js"
import style0 from "./Respiracion.vue?vue&type=style&index=0&id=6e162c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e162c3c",
  null
  
)

export default component.exports